import { useEffect, useState } from 'react'

import { Size } from '../types/types'

export const useImageSize = (url: string) => {
  const [imageSize, setImageSize] = useState<Size>(null)
  const [isFinished, setFinished] = useState(false)

  useEffect(() => {
    setImageSize(null)
    setFinished(false)
    const image = new Image()
    image.src = url
    image.onload = () => {
      setImageSize([image.width, image.height])
    }
  }, [url])

  useEffect(() => {
    if (imageSize) {
      setFinished(true)
    }
  }, [imageSize])

  return { imageSize, isFinished }
}
